import { LinkBox } from "components";
import { useLanguage } from "contexts/LocalizationContext";
import type { LinkBoxProps } from "./LinkBox.d";

const LinkBoxMagnitudeAdapter = ({ linkboxPages }: LinkBoxProps) => {
  const language = useLanguage();

  const linkItems = linkboxPages.map(({ anchor_text: anchorText, slug, topic_slug: topicSlug }) => ({
    url: `/${language}/${topicSlug}/${slug}/`,
    anchorText,
  }));

  return <LinkBox linkItems={linkItems} />;
};

export default LinkBoxMagnitudeAdapter;
